module.exports = __webpack_public_path__ + "img/accoun-bind-new.8fb7f62e.png";